import { render, staticRenderFns } from "./CraftingItem.vue?vue&type=template&id=044c0204&scoped=true"
import script from "./CraftingItem.vue?vue&type=script&lang=js"
export * from "./CraftingItem.vue?vue&type=script&lang=js"
import style0 from "./CraftingItem.vue?vue&type=style&index=0&id=044c0204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044c0204",
  null
  
)

export default component.exports